import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export interface ICampaignAvailabilityCampaign {
	id: number;
	name: string;
}

export const NotificationsPageApi = {
	fetchCampaignAvailabilityAffectedCount: async (accountId?: id | null): Promise<number> => {
		const res = await ask.get(endpoints.notificationsPage.campaignAvailabilityAffectedCount(accountId));
		return res?.payload?.affectedCount ?? 0;
	},

	fetchCampaignAvailabilityAffectedCampaigns: async (accountId?: id | null): Promise<ICampaignAvailabilityCampaign[]> => {
		const res = await ask.get(endpoints.notificationsPage.campaignAvailabilityAffectedCampaigns(accountId));
		return res?.payload?.campaigns ?? [];
	},
};
